
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./classes');
require('./bootstrap');
require('./vue-bootstrap');
require('./call-details');

// Awesome Notifier
let awnOptions = {
    position: 'top-right',
};

import AWN from "awesome-notifications"
window.notifier = new AWN(awnOptions);

require('../plugins/jquery-maskedinput/jquery.maskedinput.min');

$( function() {
    $('form').show().css('visibility', 'visible');

    $('.selectpicker').selectpicker();

    // $(".styled").uniform();

    $.busyLoadSetup({
        animation: "fade",
        background: "rgba(200, 152, 152, 0.86)",
        spinner: "circles"
    });

//Design Date Range Example (want to use the example code from QEP but it has ajax involved)
//     $('.design-daterange-example').daterangepicker({
//         "singleDatePicker": true,
//         "timePicker": true,
//         "startDate": "04/15/2019",
//         "endDate": "04/15/2019",
//         "opens": "center",
//         "applyButtonClasses": "btn-primary dark-btn",
//         "cancelClass": "btn-default close-button",
//         "showDropdowns": true,
//     }, function(start, end, label) {
//         console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
//     });
//
//     $('.design-daterange-example2').daterangepicker({
//         "singleDatePicker": true,
//         "startDate": "04/15/2019",
//         "endDate": "04/15/2019",
//         "opens": "center"
//     }, function(start, end, label) {
//         console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
//     });
//
//     $('.design-datetime-example').daterangepicker({
//         "singleDatePicker": true,
//         "timePicker": true,
//         "startDate": "05/15/2019",
//         "endDate": "05/21/2019"
//     }, function(start, end, label) {
//         console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
//     });

});

//Input Masks
//$('#phone').mask("(999) 999-9999");
//$("#postal_code").mask("a9a 9a9");


//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

//Vue.component('example-component', require('./components/ExampleComponent.vue'));

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app'
// });
